import { combineReducers } from 'redux';
import websocket from "./websocket"
const allReducers = {
  websocket,
}
const reducers = combineReducers(allReducers);
export default reducers;
